import apiClient from '../ApiClient';

export const createReview = async (payload: {
  reviewed_user_id: number;
  rating: number;
  comment: string;
}): Promise<any> => {
  const res = await apiClient.post('reviews', payload);

  return res.data;
};